import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Building2, Check } from 'lucide-react';

export default function TeamsConfigPage() {
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    let teams;
    async function init() {
      try {
        teams = await import('@microsoft/teams-js');
        await teams.app.initialize();
        // Enable the save button
        teams.pages.config.registerOnSaveHandler((saveEvent) => {
          teams.pages.config.setConfig({
            suggestedDisplayName: 'DeskFlow',
            entityId: 'deskflow-tab',
            contentUrl: `${window.location.origin}/?inTeams=true`,
            websiteUrl: `${window.location.origin}/`,
          });
          saveEvent.notifySuccess();
          setSaved(true);
        });
        teams.pages.config.setValidityState(true);
      } catch (err) {
        console.log('Teams config init skipped:', err.message);
      }
    }
    init();
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6" data-testid="teams-config-page">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex items-center justify-center gap-2 mb-2">
            <div className="h-10 w-10 rounded-xl bg-primary flex items-center justify-center">
              <Building2 className="h-5 w-5 text-primary-foreground" />
            </div>
            <span className="text-xl font-bold">DeskFlow</span>
          </div>
          <CardTitle>Configure DeskFlow Tab</CardTitle>
          <CardDescription>
            This tab shows the DeskFlow floor map and booking system.
            Click Save to add it to your channel or chat.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center">
          {saved ? (
            <div className="flex items-center justify-center gap-2 text-emerald-600" data-testid="config-saved-message">
              <Check className="h-5 w-5" />
              <span className="font-medium">Tab configured successfully</span>
            </div>
          ) : (
            <p className="text-sm text-muted-foreground">
              Click the Save button in the Teams dialog to complete setup.
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
